import { Row } from "react-bootstrap";
import { CurrentOffresStyled } from "./CurrentOffres.styled";
import { useHistory } from "react-router-dom";
import { checkIsMobile } from "../../Utills/Utill";
import locationicon from "../../images/cashbach/map-pin-fill.svg";
import directionicon from "../../images/cashbach/direction-fill.svg";

interface CurrentOffresProps {
  allMerchantsList: any;
  allOffersList: any;
}
const CurrentOffres = ({
  allMerchantsList,
  allOffersList,
}: CurrentOffresProps) => {
  const history = useHistory();
  return (
    <CurrentOffresStyled className="mt-5">
      <div className="main_container all_cate_main_wrapper">
        <div className="head_wrapper">
          <h2 className="ppl_cate_header">Ofertas Actuales</h2>
          <p className="view_all_btn">Ver Todo</p>
        </div>
       
          {allOffersList?.data?.map((item: any) => {
            const merchant = allMerchantsList?.data?.find(
              (m: any) => m?._id === item?.merchantId
            );
            return (
              <Row
              className={`list_wrapper ${checkIsMobile() && "mobile-list_wrapper"}`}
            >
              <div
                className="card-div"
                onClick={() => history.push("/Restuarante-details/" + item?._id)}
              >
                <div className="image-section">
                  <div className="inner-img-sec">
                    <img src={merchant?.merchantImageUrl} alt="UserIcon" />
                  </div>
                </div>
                <div className="text-section">
                  <h5>{item?.offerName}</h5>
                  <p>
                    {item?.offerDiscription}
                  </p>
                  <div className="location row">
                    <div className="col-6 d-flex location-section">
                      <img src={locationicon} alt="locationicon" />
                      <p>
                        {merchant?.addressline1},
                        {merchant?.addressline2} {merchant?.addressline2 && ","}
                        {merchant?.city} {merchant?.city && ","}
                        {merchant?.state} {merchant?.state && ","}
                        {merchant?.zipcode} {merchant?.zipcode && ","}
                        {merchant?.country}
                      </p>
                    </div>
                    <div className="col-6 button-section">
                      <button>
                        OBTENER DIRECCIONES
                        <img src={directionicon} alt="locationicon" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </Row>
            );
          })}
      </div>
    </CurrentOffresStyled>
  );
};

export default CurrentOffres;
